export default "__VITE_ASSET__DXx1znwf__"